const stateRoot = (state) => state.queue;

export const getIsExecuting = state => stateRoot(state).executing;

export const hasItems = state => stateRoot(state).items.length > 0;

export const getNextItem = state => stateRoot(state).items.length > 0 ? stateRoot(state).items[0] : null;
